import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./WorkerFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import WorkerFormStepTwo from "./WorkerFormSteps/WorkerFormStepTwo";
import WorkerFormStepOne from "./WorkerFormSteps/WorkerFormStepOne";
import { useEffect, useState } from "react";

const WorkerForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update } = props;
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (update) {
      setInitialValues({
        ...props.initialValues,
        position: { value: props.initialValues?.position?.uuid },
        isUser: props.initialValues.user,
        isAdmin: { value: props.initialValues.admin },
      });
      return;
    }

    setInitialValues({
      isAdmin: { value: false },
    });
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, props)}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="WorkerForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <WorkerFormStepOne {...formProps} {...props} />
              <WorkerFormStepTwo {...formProps} {...props} />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default WorkerForm;
